
import Env from '../base/env.js';
import Channels from '../base/channels.js';
import 'scroll-restoration-polyfill';
import MainnavTouch from '../ui/mainnav-touch.js'
import UISwitcher from '../ui/UIswitcher'
import Clock from '../ui/Clock'
import Launcher from '../view/launcher'
import scrollTo from 'gsap/ScrollToPlugin';

class UI
{
    constructor()
    {
        history.scrollRestoration = 'manual';
        this.resetEnv();
        this.launcher = new Launcher()
        Env.framework.mainnav = new MainnavTouch()
        this.uiSwitch =  new UISwitcher()
        this.clock = new Clock()
        this.updateMainnavActive({url: window.location.href , namespace: Env.framework.toolbox.getController() })
        this.events()
    }

    backToTop()
    {
        document.querySelector('.jsBackToTop').addEventListener('click',()=>{
            TweenLite.to(window , 1 , { scrollTo : { y : 0} , ease : Cubic.easeInOut })
        })
    }

    events()
    {
        this.backToTop()
    }

    resetEnv()
    {
        Channels.on('statechange::before',function()
        {

        })
        Channels.on('statechange::ready',(current,old,container)=>
        {
            Env.$btnBackUI.setAttribute('href','')
            Env.$btnBackUI.classList.remove('is--hidden')
            Env.$btnBackUI.classList.remove('is--ready')
            Env.$html.classList.remove('splashscreen--isIn')
            Env.$html.classList.remove('skin--isWhite')
            Env.$html.classList.remove('single--whiteUI')
        })
        Channels.on('statechange::finalize',()=>{
            this.backToTop()
        })
    }

    updateMainnavActive(context)
    {
        if(window.location.hash.length > 0)
        {
            context.url = window.location.href.split('#')[0]
        }
        for(let item of Env.$menuListeners) {
            const href = item.getAttribute('href')
            if(href == context.url) {
                item.parentElement.classList.add('is--active')
            } else {
                item.parentElement.classList.remove('is--active')
            }
        }
    }

}

export default UI;


// WEBPACK FOOTER //
// ./resources/js/view/ui.js